
<!--
 * @Description: 教职工详情 学术团体兼职
 * @Author: 张天伟
 * @Date: 2023-03-08 11:59:14
 * @LastEditors: PF
 * @LastEditTime: 2024-10-15 16:32:54
-->
<template>
  <div>
    <el-descriptions class="descript-box" v-for="(item, index) in tableData" :key="index" :column="4" border>
      <el-descriptions-item label="学术团体名称" label-align="right" align="left" width="180px" span="2">{{item.xsttmc}}</el-descriptions-item>
      <el-descriptions-item label="学术团体级别" label-align="right" align="left" width="180px" span="2">{{item.xsttjbbt}}</el-descriptions-item>
      <el-descriptions-item label="学术团体隶属或主管单位" label-align="right" align="left" width="180px" span="2">{{item.xxttlshzgdw}}</el-descriptions-item>
      <el-descriptions-item label="学术兼职职务" label-align="right" align="left" width="180px" span="2">{{item.xsjzzw}}</el-descriptions-item>
      <el-descriptions-item label="学术兼职起始日期" label-align="right" align="left" width="180px" span="2">{{item.xsjzqsrq}}</el-descriptions-item>
      <el-descriptions-item label="学术兼职结束日期" label-align="right" align="left" width="180px" span="2">{{item.xsjzzzrq}}</el-descriptions-item>
      <el-descriptions-item label="学术兼职辞职原因" label-align="right" align="left" width="180px" span="4">{{item.xsjzczyybt}}</el-descriptions-item>
      <el-descriptions-item label="" label-align="right" align="left" span="4"></el-descriptions-item>
    </el-descriptions>
  </div>
</template>

<script setup>
import { ref, defineProps, watch } from 'vue'
import { actionPost } from '@/api/common.js'

const props = defineProps({ row: { type: Object, required: false } })
const tableData = ref()

watch(
  () => props.row,
  () => {
    if (props.row) {
      const o = { url: '/api/v2/renliziyuan/jiaozhigongxueshutuantijianzhi/list', data: { id: props.row.id, order: 'gh', sort: 'asc' } }
      actionPost(o).then((res) => {
        tableData.value = res.data
      })
    }
  },
  { deep: true, immediate: true }
)
</script>
